var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.5C3.15714e-07 23.8886 0.711309 20.3127 2.09331 16.9762C3.47532 13.6398 5.50095 10.6082 8.05457 8.05456C10.6082 5.50095 13.6398 3.47532 16.9762 2.09331C20.3127 0.711308 23.8887 -4.73571e-07 27.5 0C31.1114 4.73572e-07 34.6873 0.71131 38.0238 2.09331C41.3603 3.47532 44.3918 5.50095 46.9454 8.05457C49.4991 10.6082 51.5247 13.6398 52.9067 16.9762C54.2887 20.3127 55 23.8887 55 27.5L43.2739 27.5C43.2739 25.4285 42.8659 23.3774 42.0732 21.4636C41.2804 19.5498 40.1186 17.8109 38.6538 16.3462C37.1891 14.8815 35.4502 13.7196 33.5364 12.9268C31.6226 12.1341 29.5715 11.7261 27.5 11.7261C25.4285 11.7261 23.3774 12.1341 21.4636 12.9268C19.5498 13.7196 17.8109 14.8814 16.3462 16.3462C14.8814 17.8109 13.7196 19.5498 12.9268 21.4636C12.1341 23.3774 11.7261 25.4285 11.7261 27.5H0Z",
    fill: "#D4D6DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.5C5.05374e-07 21.7192 1.82171 16.0854 5.20632 11.399C8.59092 6.71263 13.3663 3.21202 18.8539 1.39453C24.3416 -0.422969 30.2625 -0.464915 35.7753 1.27465C41.2882 3.01421 46.1127 6.44681 49.5633 11.0848L40.1554 18.0843C38.1761 15.424 35.4088 13.4551 32.2467 12.4573C29.0845 11.4595 25.6884 11.4835 22.5407 12.526C19.393 13.5685 16.6538 15.5765 14.7124 18.2646C12.7711 20.9526 11.7261 24.1842 11.7261 27.5H0Z",
    fill: "#EC6643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8);
export default __webpack_public_path__ + "static/media/Group 8.e5c9d0dadce532f91f3cb17899fbd8af.svg";
export { ForwardRef as ReactComponent };